<template>

  <v-col
    v-if="$vuetify.breakpoint.name == 'xs'"
    cols="12"
    class="pa-0 align-center"
    style="height: 100vh;display: flex;margin-top: -70px;"
  >

    <h2 class="text-center">
      <v-icon x-large class="mb-5">mdi-phone-rotate-landscape</v-icon>
      <br />
      Put your phone in landscape mode
    </h2>
  </v-col>
  <v-col v-else cols="12" class="pa-0">
    <v-tabs
      v-if="hasReports"
      :loading="loading"
      vertical
      class="report-tabs-panel"
      v-model="reportsTabModel">

      <v-list
        width="180px"
        :height="`calc(100vh - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
        dense
        :expand="options.expand"
        style="overflow-y: auto"
      >
        <v-text-field
          v-model="searchTerm"
          append-icon="search"
          class="px-2 mt-0 pt-0"
          placeholder="Search"
          clearable
          hide-details
        />
        <template v-if="!searchTerm || !reportsByTypeWithSearch.length">
          <v-list-group
            v-for="(type, kIndex) in reportsByType"
            no-action
            :value="kIndex == 0 || options.expandAll"
            :key="type.type"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="type.type"></v-list-item-title>
              </v-list-item-content>
            </template>

            <v-tab
              v-for="(report, index) in type.list"
              v-bind:key="report.alias"
              v-bind:index="report.alias"
              :href="'#' + report.alias"
              v-html="report.name"
              :data-length="reportNameSize(report.name)"
              class="resize-text"
            >
            </v-tab>
          </v-list-group>
        </template>
        <template v-else>
          <v-tab
              v-for="report in reportsByTypeWithSearch"
              :key="report.alias"
              :index="report.alias"
              :href="'#' + report.alias"
              v-html="report.name"
              :data-length="reportNameSize(report.name)"
              class="resize-text"
          />
        </template>
      </v-list>

      <v-tabs-items touchless v-model="reportsTabModel" style="width: calc(100% - 200px)">

        <template v-for="(type, kIndex) in reportsByType">
          <v-tab-item
            v-for="(report, index) in type.list"
            v-bind:key="report.alias"
            v-bind:index="report.alias"
            :value="report.alias"
          >
              <component :is="(report.dist || 'default-report')" :projectList="projectList" :title="report.name" :url="report.url" :headers="report.headers" :defaultParams="report.defaultParams" :options="report.options" :filters="report.filters || []" />
          </v-tab-item>
        </template>

      </v-tabs-items>
    </v-tabs>

    <v-sheet
      v-else
      class="d-flex flex-column align-center justify-center"
      min-height="100vh"
      color="transparent"
    >
      <v-icon
        size="72"
        color="grey lighten-1"
      >
        mdi-format-list-bulleted
      </v-icon>

      <div class="text-h6 mt-4">
        No reports
      </div>

      <div class="grey--text mt-2">
        You do not have access to any reports yet
      </div>
    </v-sheet>
  </v-col>
</template>

<style>

  .resize-text[data-length="size-25"] {
    font-size: 0.6em;
  }

  .resize-text[data-length="size-20"] {
    font-size: 0.7em;
  }

  .resize-text[data-length="size-15"] {
    font-size: 0.8em;
  }

  .report-tabs-panel {
    /*display: -webkit-box;*/
  }

  .report-tabs-panel .v-list-group,
  .report-tabs-panel .v-list-group__items {
    border-top: 1px solid #c0c1c2;
  }

  .report-tabs-panel .v-list-group__items {
    border-top: 1px solid #c0c1c2;
  }

  .report-tabs-panel .v-list-group:last-child {
    border-bottom: none;
  }

  .report-tabs-panel .v-list-item__icon {
    min-width: 24px !important;
    margin-left: 5px;
  }

  .report-tabs-panel .v-list-item__icon.v-list-group__header__append-icon {
    margin-left: 5px !important;
  }

  .report-tabs-panel .v-list-group__header {
    padding-left: 10px;
    padding-right: 4px;
  }
</style>

<script>
  import { map, toArray, reduce, get } from 'lodash'
  import { API } from '@/utils/api'

  export default {
    data: () => ({
      expand: [ true, false, false ],
      dateRangeList,
      reportsTabModel: null,
      reports: [],
      loading: true,
      options: {
        expand: true,
        expandAll: true
      },
      searchTerm: '',
    }),

    components: {
      DefaultReport: () => import('@/components/report/Default'),
      CashbackCalc: () => import('@/components/report/CashbackCalc'),
      AcceptanceRate: () => import('@/components/report/AcceptanceRate'),
      ChurnRate: () => import('@/components/report/ChurnRate'),
      ClosedAccountsByPeriod: () => import('@/components/report/ClosedAccountsByPeriod'),
      TransactionsByPaymethod: () => import('@/components/report/TransactionsByPaymethod'),
      Choropleth: () => import('@/components/report/Choropleth'),
      LoyaltyPoints: () => import('@/components/report/LoyaltyPoints'),
    },
    computed: {
      projectList: function () {
        return map(this.$store.state.auth.entities, (i) => ({ text: i.name, value: i.entity_id }))
      },
      reportsByType: function () {
        return toArray(reduce(this.reports, (r, o, i) => {
          if (!r[o.type]) {
            r[o.type] = { type: o.type, list: [], expand: i == 0 }
          }
          r[o.type]['list'].push(o)
          return r
        }, {}))
      },
      reportsByTypeWithSearch () {
        if (!this.searchTerm) {
          return this.reportsByType
        }

        const searchTermFormatted = this.searchTerm.trim().toLowerCase()
        if (!searchTermFormatted) {
          return this.reportsByType
        }

        const result = []
        for (const { list } of this.reportsByType) {
          const matchingReports = list.filter(entry => entry.alias.toLowerCase().includes(this.searchTerm) || entry.name.toLowerCase().includes(this.searchTerm))
          if (matchingReports.length) {
            result.push(...matchingReports)
          }
        }

        return result
      },

      hasReports() {
        return this.reportsByType.length !== 0
      },
    },

    methods: {

      loadReportList () {
        return API.call('/reports/list.json', {}, null, null).then(resp => {

          this.reports = get(resp, 'data', [])

          return resp.data
        }).catch(e => {
        }).finally(() => {
          this.loading = false
        })
      },

      updateExpand: function (kIndex) {
        this.$set(this.expand, kIndex, !this.expand[kIndex])
      },

      reportNameSize: function (name) {
        let nameLength = name.split(/<br\s*\/?>/i).reduce((max, line) => Math.max(max, line.trim().length), 0)
        let textSize = 'regular'

        if (nameLength > 25) {
          textSize = 'size-25'
        } else if (nameLength > 20) {
          textSize = 'size-20'
        } else if (nameLength > 15) {
          textSize = 'size-15'
        }

        return textSize
      }
    },

    mounted () {

      this.loadReportList()

      let _this = this
      this.$loader.loaded = false
      setTimeout(function () {
        _this.options.expand = false
        _this.options.expandAll = false
        _this.$loader.loaded = true
      }, 1000)

    },
  }
</script>
